module.exports = __webpack_public_path__ + "img/MEDIA111.4a384667.jpg";